import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const CardGroup = forwardRef<HTMLDivElement, BSDiv>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div {...props} className={`card-group ${className}`} ref={ref}>
        {children}
      </div>
    );
  }
);